import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IElementMultiSelect} from '../../../../../incase-domain/elements/question/multiSelect';
import {IElementPhotoAnswerQuestion} from '../../../../../incase-domain/elements/question/photoAnswerQuestion';
import {IElementQuestion} from '../../../../../incase-domain/elements/question/question';
import {IElementSequenceQuestion} from '../../../../../incase-domain/elements/question/questionSequence';
import {getBorderStyle} from '../../../../../util/style.utils';
import {IElementQuestionYesNo} from '../../../../../incase-domain/elements/question/questionYesNo';
import {IElementQuestionYesNoV2} from '../../../../../incase-domain/elements/question/questionYesNoV2';

type IStyleElementTypes =
    | IElementQuestion
    | IElementSequenceQuestion
    | IElementMultiSelect
    | IElementPhotoAnswerQuestion
    | IElementQuestionYesNo
    | IElementQuestionYesNoV2;

export function getAnswerStyles(device: DeviceType, element: IStyleElementTypes): React.CSSProperties {
    let shared = {
        borderRadius: getBorderStyle(element.borderRadius),
        fontFamily: element.fontFamily?.name,
    } as React.CSSProperties;

    if ('answerTextAlign' in element) {
        shared = {...shared, textAlign: `${element.answerTextAlign || 'initial'}`} as React.CSSProperties;
    }

    if (device === DeviceType.MOBILE) {
        return shared;
    }

    return {
        ...shared,
        fontSize: `${element.fontSize}em`,
    } as React.CSSProperties;
}

export function getCommentStyles(device: DeviceType, element: IStyleElementTypes): React.CSSProperties {
    let shared = {
        borderRadius: getBorderStyle(element.borderRadius),
        fontFamily: element.fontFamily?.name,
    } as React.CSSProperties;

    if ('answerTextAlign' in element) {
        shared = {...shared, textAlign: `${element.answerTextAlign || 'initial'}`} as React.CSSProperties;
    }

    if (device === DeviceType.MOBILE) {
        return shared;
    }

    return {
        ...shared,
        fontSize: `${element.commentFontSize}em`,
    } as React.CSSProperties;
}
